import { VISIT_ANALYTICS } from './../config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case VISIT_ANALYTICS:
            return action.payload;
        default:
            return state;
    }
}

export default reducer;
